import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ThemeModeService } from './_layout/components/theme-mode-switcher/theme-mode.service';
import rg4js from 'raygun4js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly _modalService = inject(NgbModal);
  private readonly _router = inject(Router);
  private readonly _themeService = inject(ThemeModeService);

  private _bindRouter() {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        rg4js('trackEvent', { type: 'pageView', path: event.url });
      }

      if (event instanceof NavigationError) {
        rg4js('send', { error: event.error });
      }

      if (event instanceof NavigationStart) {
        this._modalService.dismissAll();
      }
    });
  }

  ngOnInit() {
    this._bindRouter();
    this._themeService.init();
  }
}
